/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Illegal_Char_TitleInputs */



/**
* | output |
* | --- |
* | "Illegal Character Detected" |
*
* @param {Embed_Captions_Illegal_Char_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_illegal_char_title = /** @type {((inputs?: Embed_Captions_Illegal_Char_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Illegal_Char_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractere illegal detecte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Zeichen erkannt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carattere illegale rilevato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружен недопустимый символ.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carácter ilegal detectado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测到非法字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不正な文字が検出されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवैध वर्ण का पता चला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caractere ilegal detectado")
	return /** @type {LocalizedString} */ ("Illegal Character Detected")
});